<p-blockUI [blocked]="blocked">
    <div id="center" style="margin-top:260px; margin-left:800px;">
      <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
    </div>
  </p-blockUI>
  <div class="ui-g-12 mt-2">
    <p-confirmDialog></p-confirmDialog>
    <div class="ui-g-12">
      <div class="ui-g-2">
      </div>
      <div class="ui-g-4 border border-info rounded text-center">
        <label class="h4">Search</label>
        <div class="ui-g-12">
          <p-radioButton name="groupname" value="batch" label="Batch" [(ngModel)]="searchSelection"></p-radioButton>
          <p-radioButton name="groupname" class="ml-3" value="sample" label="Sample" [(ngModel)]="searchSelection"></p-radioButton>
          <p-radioButton name="groupname" class="ml-3" value="chaotincPool" label="Chaotic Pool" [(ngModel)]="searchSelection"></p-radioButton> 
          <p-radioButton name="groupname" class="ml-3" value="pool" label="Pool" [(ngModel)]="searchSelection"></p-radioButton>
          <p-radioButton name="groupname" class="ml-3" value="lolliPooling" label="Lolli Poolling" [(ngModel)]="searchSelection"></p-radioButton>
          <p-radioButton name="groupname" class="ml-3" value="NCSampleSearch" label="Nc-Sample" [(ngModel)]="searchSelection"></p-radioButton>
          <p-radioButton name="groupname" class="ml-3" value="bagIdSearch" label=" Bag-ID" [(ngModel)]="searchSelection"></p-radioButton>
          <p-radioButton name="groupname" class="ml-3" value="boxIdSearch" label="Box-ID" [(ngModel)]="searchSelection"></p-radioButton>
        </div>
        <div class="ui-g-12">
          <input pInputText type="text" #idInput id="searchField" placeholder="Enter ID to search" (keyup.enter)="search(idInput.value)"/>
          <button pButton label="Go" [disabled]="disableSearchIf(idInput.value)" (click)="search(idInput.value)"></button>
        </div>
      </div>
      <div class="ui-g-4">
        <div class="ui-g-4">
          <div class = "display: flex; justify-content: flex-end">
            <button pButton class="theme-button" type="button" label="Printing" (click)="openPrintingDialog()"  [disabled]="disableAdmin()"></button>
          </div>
        </div>                   
      </div>      
    </div>
    <div class="ui-g-2" *ngIf="searchSuccess||sampleSearch">
    </div>
    <div class="ui-g-8" *ngIf="searchSuccess">
      <div class="ui-g-12 border border-info rounded">
        <div class="text-center">
        <div class="ui-g-12">
          <label class="h5">
            {{searchedBatch?.batchID}}
          </label>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-6 ui-inputgroup" id="inputClass">
            <button pButton class="theme-button labelButton" type="button" label="Sender"></button>
            <input pInputText class="senders" placeholder="Sender Name" [value]="batchSenderNames" readonly />
          </div>
          <div class="ui-g-6 ui-inputgroup" id="inputClass">
            <button pButton class="theme-button labelButton" type="button" label="Status"></button>
            <input pInputText placeholder="Status of the Batch" [value]="searchedBatch?.statusOfTheBatch" readonly />
          </div>
          <div class="ui-g-6 ui-inputgroup" id="inputClass">
            <button pButton class="theme-button labelButton" type="button" label="Sample Count"></button>
            <input pInputText placeholder="Sample Count" [value]="searchedBatch?.sampleListSizeWithoutControls"
              readonly />
          </div>
          <div class="ui-g-6 ui-inputgroup" id="inputClass">
            <button pButton class="theme-button labelButton" type="button" label="Delivery Date"></button>
            <input pInputText placeholder="Delivery Recieved Date"
              value="{{searchedBatch?.deliveryReceivedDateTime | date: 'dd.MM.yy HH:mm' }}" readonly />
          </div>
          <div class="ui-g-6 ui-inputgroup" id="inputClass">
            <button pButton class="theme-button labelButton" type="button" label="Redo Reason"></button>
            <input pInputText placeholder="Redo Reason"
              value="{{searchedBatch?.redoReason}}" readonly />
          </div>
          <div class="ui-g-6 ui-inputgroup" id="inputClass">
            <button pButton class="theme-button labelButton" type="button" label="Complete Date"></button>
            <input pInputText placeholder="Complete Date"
              value="{{searchedBatch?.resultSentDateTime | date: 'dd.MM.yy HH:mm' }}" readonly />
          </div>
          <div class="ui-g-6 ui-inputgroup" id="inputClass">
            <button pButton class="theme-button noHover labelButton" type="button" label="History"></button>
            <p-dropdown *ngIf="searchedBatch.wellType == 'WELL384'" [options]="groupedBatches" placeholder="Select a Batch"
              [group]="true" (onChange)="idInput.value=$event.value;search($event.value)" scrollHeight="500px">
              <ng-template let-group pTemplate="group">
                <div class="p-d-flex p-ai-center mt-2">
                  <span>{{group.label}}</span>
                </div>
              </ng-template>
            </p-dropdown>
            <p-dropdown *ngIf="searchedBatch.wellType == 'WELL96'" [options]="batchHistory" placeholder="Select a Batch"
              (onChange)="idInput.value=$event.value;search($event.value)">
            </p-dropdown>
          </div>
          <div class="ui-g-6 ui-inputgroup" id="inputClass">
            <button pButton class="theme-button labelButton mr-2" type="button" label="NC-Batch"></button>
            <p-checkbox id="active" [(ngModel)]="searchedBatch.ncSample" binary="true" disabled="true"></p-checkbox>
          </div>
          <div class="ui-g-12">
            <button pButton class="font-weight-bold" label="View All Comments" icon="fa fa-comments" (click)="showComments(true)"></button>
          </div>
        </div>
      </div>
    <p-fieldset  legend="Update Batch" toggleable="true">
      <div class="ui-g">
        <div class="ui-g-9">
          <button pButton class="theme-button labelButton" type="button" label="Reset Status"></button>
          <p-dropdown [options]="statusListWithArchive" [(ngModel)]="selectedResetStatus" [style]="{ 'height' : '100%' }"
            placeholder="Reset batch to status"></p-dropdown>
        </div>
        <div class="ui-g-3">
          <button class="btn redobutton float-right btn-width" [disabled]="redoDisabled()" (click)="setRedoStep()">Redo</button>
        </div>
        <div class="ui-g-9">
          <button pButton class="theme-button labelButton mr-2" type="button" label="Rush"></button>
          <p-checkbox id="active" [(ngModel)]="searchedBatch.rushSample" binary="true"></p-checkbox>
        </div>
        <div class="ui-g-3">
          <button type="button" class="btn remove-unnecessary float-right btn-width" [disabled]="removeUnnecessaryRedoDisabledIf()"
            (click)="selectBatchToComplete()">Remove Unnecessary Redo</button>
        </div>
        <div class="ui-g-9">
          <button pButton class="theme-button labelButton mr-2" type="button" label="Super Rush"></button>
          <p-checkbox id="superRush" [(ngModel)]="searchedBatch.superRush" binary="true"></p-checkbox>
        </div>
        <div class="ui-g-3">
          <button type="button" class="btn false-redo float-right btn-width" [disabled]="changeFalseRedoDisabledIf()"
            (click)="confirmFalseRedo()">Change False Redo</button>
        </div>
        <div class="ui-g-9">
          <button pButton class="theme-button labelButton mr-2" style="background-color:#e79aad;border-color: #e79aad"
            type="button" label="locked"></button>
          <p-checkbox id="active" [(ngModel)]="searchedBatch.locked" binary="true"></p-checkbox>
        </div>
        <div class="ui-g-3">
          <button type="button" class="btn btn-danger float-right btn-width" [disabled]="removeDisabledIf()"
            (click)="confirmRemoveBatch()">Remove
            Batch</button>
        </div>
        <div class="ui-g-9">
          <button pButton class="theme-button labelButton" type="button" label="Reset Workflow"></button>
          <p-dropdown [options]="workFlowDropDwon"  [(ngModel)]="selectedWorkFlow"  [style]="{ 'height' : '100%' }"
            placeholder="Reset Workflow" [readonly]="isResetWorkflowDropdownReadOnly"></p-dropdown>
              <button pButton class="font-weight-bold" [disabled]="isUpdateWorkflowBtnDisabled" (click)="updateWorkflow()"
              label="Update Workflow"></button>
            
        </div>
        
        <div class="ui-g-6">
          <button pButton class="float-left font-weight-bold" style="width: 50%;" [disabled]="disableUpdateBatch()"
            (click)="resetStatus()" label="Update Status"></button>
        </div>
       
        <div class="ui-g-6">
          <button type="button" class="btn complete float-right btn-width" [disabled]="isDisabledCompleteBatch()"
            (click)="confirmCompleteBatch()">Complete Batch</button>
        </div>
      </div>
      </p-fieldset>
      </div>
    </div>
    <div class="ui-g-8" *ngIf="sampleSearch">
      <table aria-describedby="Sample Information Table" class="sampleTable">
        <tbody class="sampleTableBody">
          <tr>
            <th scope="row">Barcode</th>
            <td>{{sampleInfo.barcode}}</td>
            <th scope="row">Document Barcode</th>
            <td>{{sampleInfo.documentBarcode}}</td>
          </tr>
          <tr>
            <th scope="row">Customer Barcode</th>
            <td>{{sampleInfo.customersBarcode}}</td>
            <th scope="row">Box ID</th>
            <td>{{sampleInfo.boxId}}</td>
          </tr>
          <tr>
            <th scope="row">Unboxing Batch</th>
            <td>{{sampleInfo.unboxedBatch}}</td>
            <th scope="row">Clipping Batch</th>
            <td>{{sampleInfo.clippingBatch}}</td>
          </tr>

          <tr>
            <th scope="row">Unboxed Batch Sender</th>
            <td>{{sampleInfo.sender}}</td>
            <th scope="row">Sample Sender</th>
            <td>{{sampleInfo.unboxedSender}}</td>
          </tr>
          <tr>
            <th scope="row">Primary Result 1 Analysis</th>
            <td class="text-uppercase font-weight-bold" [ngStyle]="getStyleForResult(primarySampleResult1)">{{primarySampleResult1}}</td>
            <th scope="row">Secondary Result 1 Analysis</th>
            <td class="text-uppercase font-weight-bold" [ngStyle]="getStyleForResult(secondarySampleResult1)">{{secondarySampleResult1}}</td>
          </tr>
          <tr>
            <th scope="row">Primary Result 2 Analysis</th>
            <td class="text-uppercase font-weight-bold" [ngStyle]="getStyleForResult(primarySampleResult2)">{{primarySampleResult2}}</td>
            <th scope="row">Secondary Result 2 Analysis</th>
            <td class="text-uppercase font-weight-bold" [ngStyle]="getStyleForResult(secondarySampleResult2)">{{secondarySampleResult2}}</td>
          </tr>
          <tr>
            <th scope="row">Single Sample Redo Count</th>
            <td>{{singleSampleRedoCount}}</td>
            <th scope="row"></th>
            <td></td>
          </tr>
          <tr>
            <th scope="row">Last Processed Batch</th>
            <td>{{sampleInfo.analysisBatch}}</td>
            <th scope="row">Current Status</th>
            <td>{{sampleInfo.status}}</td>
          </tr>
          <tr>
            <th scope="row">Comments</th>
            <td colspan="3"><button pButton class="font-weight-bold" label="View All Comments" icon="fa fa-comments" (click)="showComments(false)"></button></td>
          </tr>
          <tr>
            <th scope="row">Delivery Destination</th>
            <td colspan="3"><input pInputText name="SearchBatch" [(ngModel)]="destination" placeholder="Destination">
              <button pButton class="font-weight-bold shiptoSenderbtn" label="Ship to Sender" (click)="shipToSender()" [disabled]="disableShiptoSender()"></button>
            {{sampleInfo.shippedUserPUID}} / {{sampleInfo.shippedTimestamp?.$date  | date: 'dd.MM.yy HH:mm'}} </td>
          </tr>
          <tr>
            <th scope="row">Results</th>
            <td colspan="3"><button pButton class="font-weight-bold" label="View All Results" icon="fa fa-list-alt" (click)="showResultDialog = true"></button></td>
          </tr>
        </tbody>
      </table>

    </div>
    <div class="ui-g-2" *ngIf="sampleSearch">
      <div class="ui-g-12">
        <div class="btn-group w-100">
          <button class="btn btn-danger dropdown-toggle" type="button" data-toggle="dropdown" [disabled]="!validRole || sampleInfo.status=='COMPLETED'" aria-haspopup="true" aria-expanded="false">
            Delete Sample From
          </button>
          <div class="dropdown-menu">
            <a class="dropdown-item" (click)="batchIdPopup=true">Single Batch</a>
            <a class="dropdown-item" (click)="deleteSample(idInput)">All Batches</a>
          </div>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="btn-group w-100">
          <button class="btn btn-info" type="button" [disabled]="!isRedoSamleButtonEnable()" aria-haspopup="true" aria-expanded="false" (click)="onRedoSampleClick()"  [disabled]="disableAdmin()">
            Redo sample
          </button>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="btn-group w-100">
          <button pButton class="noHover button-large" type="button"
                label="Create NC Sample" (click)="isNCSamplePopup=true"  [disabled]="disableAdmin()"></button>
        </div>
      </div>
    </div>
    <div class="ui-g-9" *ngIf="sampleSearch" style="margin-left:10.5rem;">
      <p-table [columns]="cols" [value]="sampleAllHistory" styleClass="p-datatable-gridlines" responsiveLayout="scroll"
        class="sampleTableBody1">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col" *ngFor="let col of columns">
              {{col.header}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td *ngFor="let col of columns">
              {{rowData[col.field]}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="ui-g-1" *ngIf="chaotincPoolSearch">
    </div>
    <div class="ui-g-10" *ngIf="chaotincPoolSearch">
      <table aria-describedby="Pool Information Table" class="poolTable">
        <tbody class="poolTableBody">
          <tr>
            <th scope="row">Barcode</th>
             <td colspan="2" [ngStyle]="getChaoticBgColor(barcode)"> 
               {{barcode}}
            </td>
          </tr>
          <tr>
            <th scope="row">Pooling Box-ID</th>
            <td colspan="2">
             
            </td>
          </tr>
          <tr>
            <th scope="row">Sample Sender</th>
            <td colspan="2">
              {{ batchSenderNames }}
            </td>
          </tr>
          <tr>
            <th scope="row">Unboxing Batch</th>
            <td colspan="2">
           
            </td>
          </tr>
          <tr>
            <th scope="row">Target Batch</th>
            <td   colspan="2">
              {{batchID}}
            </td>
          </tr>
          <tr>
            <th scope="row">Analysis Batch</th>
            <td  colspan="2">
              
            </td>
          </tr>
          <tr>
            <th scope="row">Analysis Position</th>
            <td  colspan="2">
              
            </td>
          </tr>
          <tr>
            <th scope="row">Depooled</th>
            <td  colspan="2">
             
            </td>
          </tr>
          <tr>
            <th scope="row">Status</th>
            <td  colspan="2">
              
            </td>
          </tr>
          <tr>
            <th scope="row"></th>
            <th scope="row">Sample-ID</th>
            <th scope="row">Source Batch-ID</th>
          </tr>         
          <tr *ngFor="let item of myMap | keyvalue;let i = index" colspan="2"> 
            <th scope="row"></th>
            <td [ngStyle]="getChaoticBgColor(item.key)">{{item.key}}</td>
            <td>{{item.value}}</td>
          </tr> 
          <tr> 
            <th scope="row">Comments</th>
            <td colspan="2">
              <button pButton class="font-weight-bold" label="View All Comments" icon="fa fa-comments" (click)="showComments(true)"></button>
            </td>
          </tr>
          <tr>
            <th scope="row">Results</th>
            <td colspan="2">
              <button pButton class="font-weight-bold" label="View All Results" icon="fa fa-list-alt" (click)="showResultDialog = true"></button>
            </td>
          </tr>
          <tr>
            <th scope="row">Delivery</th>
            <td colspan="2"></td>
          </tr>
        </tbody>  
      </table>         
    </div>
    <div class="ui-g-1" *ngIf="preperationPoolSearch">
    </div>
    <div class="ui-g-10" *ngIf="preperationPoolSearch">
      <table aria-describedby="Pool Information Table" class="poolTable">
        <tbody class="poolTableBody">
          <tr>
            <th scope="row">Barcode</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
              {{ i==0? poolSearchId:'' }}
            </td>
          </tr>
          <tr>
            <th scope="row">Pooling Box-ID</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
            {{item.boxId}}
            </td>
          </tr>
          <tr>
            <th scope="row">Sample Sender</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
              {{item.sender}}
            </td>
          </tr>
          <tr>
            <th scope="row">Unboxing Batch</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
              {{item.covid19PoolSampleInfo.unboxedBatch}}
            </td>
          </tr>
          <tr>
            <th scope="row">Clipping Batch</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
              {{item.covid19PoolSampleInfo.clippingBatch}}
            </td>
          </tr>
          <tr>
            <th scope="row">Clipping Position</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
              {{getPositionString(item.covid19PoolSampleInfo.clippingBatchRow, item.covid19PoolSampleInfo.clippingBatchCol)}}
            </td>
          </tr>
          <tr>
            <th scope="row">Analysis Batch</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
              {{item.covid19PoolSampleInfo.analysisBatch}}
            </td>
          </tr>
          <tr>
            <th scope="row">Analysis Position</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
              {{getPositionString(item.covid19PoolSampleInfo.positionRow, item.covid19PoolSampleInfo.positionCol)}}
            </td>
          </tr>
          <tr>
            <th scope="row">Status</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
              {{item.covid19PoolSampleInfo.status}}
            </td>
          </tr>
          <tr>
            <th scope="row">Redo Batches</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
              {{item.covid19PoolSampleInfo.redoBatches}}
            </td>
          </tr>
          <tr>
            <th scope="row">Superpool-ID</th>
            <td [attr.colspan]="covid19PoolsToBeDisplayed.length"
              [ngStyle]="getBgColor(covid19PoolsToBeDisplayed[0].superPoolId)">{{covid19PoolsToBeDisplayed[0].superPoolId}}</td>
          </tr>
          <tr>
            <th scope="row">Pool-IDs</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index"
                [ngStyle]="getBgColor(covid19PoolsToBeDisplayed[i].poolId)">
              {{covid19PoolsToBeDisplayed[i].poolId}}
            </td>
          </tr>
          <tr *ngFor="let in of counter(pooledSamplesMaxSize); let rowIndex = index">
            <th scope="row"></th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index"
                [ngStyle]="getBgColor(covid19PoolsToBeDisplayed[i].samples[rowIndex])">
              {{covid19PoolsToBeDisplayed[i].samples.length>rowIndex ? covid19PoolsToBeDisplayed[i].samples[rowIndex] : ''}}
            </td>
          </tr>
          <tr>
            <th scope="row">Comments</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
              <button pButton class="font-weight-bold" label="View All Comments" icon="fa fa-comments" (click)="showComments(false)"></button>
            </td>
          </tr>
          <tr>
            <th scope="row">Results</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index">
              <button pButton class="font-weight-bold" label="View All Results" icon="fa fa-list-alt" (click)="showResultDialog = false"></button>
            </td>
          </tr>
          <tr>
            <th scope="row">Delivery Destination</th>
            <td *ngFor="let item of covid19PoolsToBeDisplayed;let i = index" >
             {{item.covid19PoolSampleInfo.shippedUserPUID}} / {{item.covid19PoolSampleInfo.shippedTimestamp?.$date  | date: 'dd.MM.yy HH:mm'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="ui-g-1" *ngIf="poolSearch">
    </div>
    <div class="ui-g-10" *ngIf="poolSearch">
      <table aria-describedby="Pool Information Table" class="poolTable">
        <tbody class="poolTableBody">
          <tr>
            <th scope="row">Barcode</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples ;let i = index">
              {{ i==0? poolSearchId:'' }}
            </td>
          </tr>
          <tr>
            <th scope="row">Pooling Box-ID</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index">
            {{item.boxId}}
            </td>
          </tr>
          <tr>
            <th scope="row">Sample Sender</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index">
              {{item.sender}}
            </td>
          </tr>
          <tr>
            <th scope="row">Unboxing Batch</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index">
              {{item.unboxedBatch}}
            </td>
          </tr>
          <tr>
            <th scope="row">Clipping Batch</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index">
              {{item.clippingBatch}}
            </td>
          </tr>
          <tr>
            <th scope="row">Clipping Position</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index">
              {{getPositionString(item.clippingBatchRow, item.clippingBatchCol)}}
            </td>
          </tr>
          <tr>
            <th scope="row">Analysis Batch</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index">
              {{item.analysisBatch}}
            </td>
          </tr>
          <tr>
            <th scope="row">Analysis Position</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index">
              {{getPositionString(item.positionRow, item.positionCol)}}
            </td>
          </tr>
          <tr>
            <th scope="row">Status</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index">
              {{item.poolIdStatus}}
            </td>
          </tr>
          <tr>
            <th scope="row">Redo Batches</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index">
              {{item.redoBatches}}
            </td>
          </tr>
          <tr>
            <th scope="row">Superpool-ID</th>
            <td [attr.colspan]="covid19SuperPoolsToBeDisplayedView.poolSamples.length"
              [ngStyle]="getBgColor(covid19SuperPoolsToBeDisplayed.superPoolId)">{{covid19SuperPoolsToBeDisplayedView.superPoolId}}</td>
          </tr>
          <tr>
            <th scope="row">Pool-IDs</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index"
                [ngStyle]="getBgColor(covid19SuperPoolsToBeDisplayedView.poolSamples[i].poolId)">
              {{covid19SuperPoolsToBeDisplayedView.poolSamples[i].poolId}}
            </td>
          </tr>
          <tr *ngFor="let in of counter(pooledSamplesMaxSize); let rowIndex = index">
            <th scope="row"></th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index"
                [ngStyle]="getBgColor(covid19SuperPoolsToBeDisplayedView.poolSamples[i].barcode[rowIndex])">
              {{covid19SuperPoolsToBeDisplayedView.poolSamples[i].barcode.length>rowIndex ? covid19SuperPoolsToBeDisplayedView.poolSamples[i].barcode[rowIndex] : ''}}
            </td>
          </tr>
          <tr>
            <th scope="row">Comments</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index">
              <button pButton class="font-weight-bold" label="View All Comments" icon="fa fa-comments" (click)="showComments(false)"></button>
            </td>
          </tr>
          <tr>
            <th scope="row">Results</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index">
              <button pButton class="font-weight-bold" label="View All Results" icon="fa fa-list-alt" (click)="showResultDialog = false"></button>
            </td>
          </tr>
          <tr>
            <th scope="row">Delivery Destination</th>
            <td *ngFor="let item of covid19SuperPoolsToBeDisplayedView.poolSamples;let i = index" >
             {{item.shippedUserPUID}} / {{item.shippedTimestamp?.$date  | date: 'dd.MM.yy HH:mm'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="ui-g-2" *ngIf="falconSampleSearch || bagIdSampleSearch">
    </div>
    <div class="ui-g-4" *ngIf="falconSampleSearch || bagIdSampleSearch">
      <table aria-describedby="Lolli-Falcon Information Table" class="sampleTable">
        <tbody class="sampleTableBody">
          <tr>
            <th scope="row">Falcon-ID</th>
            <td>{{depoolingRetestDTO.falconID}}</td>
          </tr>
          <tr>
            <th scope="row">Box ID</th>
            <td>{{depoolingRetestDTO.boxID}}</td>
          </tr>
          <tr>
            <th scope="row">School ID</th>
            <td>{{depoolingRetestDTO.schoolID}}</td>
          </tr>
          <tr>
            <th scope="row">Bag ID</th>
            <td>{{depoolingRetestDTO.bagID}}</td>
          </tr>
          <tr>
            <th scope="row">Combination-ID</th>
            <td>{{depoolingRetestDTO.superPoolID}}</td>
          </tr>
          <tr>
            <th scope="row">Strorage Place</th>
            <td>{{depoolingRetestDTO.storageID}}</td>
          </tr>
          <tr>
            <th scope="row">Sample Sender</th>
            <td>{{depoolingRetestDTO.sender}}</td>
          </tr>
          <tr>
            <th scope="row">Received</th>
            <td>{{getRecvDate(depoolingRetestDTO.resultReceivedDate) | date: 'dd.MM.yy HH:mm'}}</td>
          </tr>
          <tr>
            <th scope="row">External Result</th>
            <td>{{depoolingRetestDTO.externalResult}}</td>
          </tr>
          <tr>
            <th scope="row">Retest Batch</th>
            <td>{{samplesBatchID}}</td>
          </tr>
          <tr *ngFor="let item of unBoxedSamples;let i = index">
            <th *ngIf="unBoxedSamples.length > 0 && i === 0" scope="row">Retest Single Samples</th>
            <th *ngIf="unBoxedSamples.length > 0 && i > 0" scope="row"></th>
            <td *ngIf="unBoxedSamples.length > 0">{{item.eurofinsBarcode}}</td>
          </tr>
          <tr *ngIf="unBoxedSamples.length === 0">
            <th scope="row">Retest Single Samples</th>
            <td></td>
          </tr>
        </tbody>
      </table>
      <div style="text-align: center;margin-top: 2%;">
        <div>
          <button pButton id="editUnwrappedSample" label="Edit Entry" [disabled]="!this.validRole"
          (click)="openEditUnwrappedSamplePopup()" class="noHover" class="buttonsRound startButton"></button>
        </div>
        <div>
          {{getRecvDate(depoolingRetestDTO.lastModifiedDate) | date: 'dd.MM.yy HH:mm'}} {{depoolingRetestDTO.lastModifiedBy}}
        </div>
      </div>
    </div>
    <div class="ui-g-2" *ngIf="boxIdSampleSearch">
    </div>
    <div class="ui-g-4" *ngIf="boxIdSampleSearch">
      <table aria-describedby="Lolli-BOxID Information Table" class="sampleTable">
        <thead class="sampleTableBody">
          <th scope="row">Falcon-ID</th>
          <th scope="row">Box ID</th>
          <th scope="row">School ID</th>
          <th scope="row">Bag ID</th>
          <th scope="row">Sample Sender</th>
        </thead>
        <tbody class="sampleTableBody">
          <tr *ngFor="let item of depoolingRetestList;let i = index">  
            <td>{{item.falconID}}</td>
            <td>{{item.boxID}}</td>
            <td>{{item.schoolID}}</td>
            <td>{{item.bagID}}</td>
            <td>{{item.sender}}</td>
          </tr>
        </tbody>

      </table>
    </div>

  </div>
  <div class="ui-g-1" *ngIf="showNcSample">
    </div>
    <div class="ui-g-10" *ngIf="showNcSample" >
      <div class="ui-g-12 border border-info rounded">
        <div class="text-center">
        <div class="ui-g-12">
          <label class="h5">
            Details of NC Sample Report
          </label>
          </div>
        </div>
      <div style="padding-bottom: 1em;">
    <p-fieldset  legend="Nc Sample Info" toggleable="true">
      <div class="text-center">
      <div class="ui-g-12">
        <div class="ui-g-6 ui-inputgroup" id="inputClass">
          <button pButton class="theme-button labelButton" type="button" label="Barcode"></button>
          <input pInputText class="senders" placeholder="Barcode" [(ngModel)] = "samples.barcode"  readonly />
        </div>
        <div class="ui-g-6 ui-inputgroup" id="inputClass">
          <button pButton class="theme-button labelButton" type="button" label="Box ID"></button>
          <input pInputText class="senders" placeholder="Box ID" [(ngModel)] = "samples.boxID" readonly />
        </div>
        <div class="ui-g-6 ui-inputgroup" id="inputClass">
          <button pButton class="theme-button labelButton" type="button" label="Alt-Barcode"></button>
          <input pInputText class="senders" placeholder="Alt-Barcode" [(ngModel)] = "samples.ncBarcode"  readonly />
        </div>
        <div class="ui-g-6 ui-inputgroup" id="inputClass">
          <button pButton class="theme-button labelButton" type="button" label="Alt-Add-Barcode"></button>
          <input pInputText class="senders" placeholder="Alt-Add-Barcode" [(ngModel)] = "samples.altAddBarCode"  readonly />
        </div>
        <div class="ui-g-6 ui-inputgroup" id="inputClass">
          <button pButton class="theme-button labelButton" type="button" label="Sample Type"></button>
          <input pInputText placeholder="Sample Type" [(ngModel)] = "samples.sampleType"
            readonly />
        </div>
        <div class="ui-g-6 ui-inputgroup" id="inputClass">
          <button pButton class="theme-button labelButton" type="button" label="Box Received"></button>
          <input pInputText placeholder="Box Recieved Date" value="{{samples.receptionDate | date: 'dd.MM.yy HH:mm'}}"
           readonly />
        </div>
      </div>
      </div>
      </p-fieldset>
      </div>
      <div style="padding-bottom: 1em;">
        <p-fieldset legend="Images" toggleable="true">
          <div class="ui-g-2 previewWindow border p-0" *ngFor="let image of newimages;let indexOfimage=index;"
            style="margin-left: 2rem;">
            <img *ngIf="newimages[0]" src = {{image}} alt="Add" width="100%"
              height="100%" />
          </div>
        </p-fieldset>
      </div>
       <div style="padding-bottom: 1em;">
        <p-fieldset  legend="Problem list" toggleable="true">
          <div class="ui-g-12 p-0">
            <ul *ngFor="let problem of selectedProblems">
              <li [ngClass]="{'font-weight-bold':problem.extProblemCode === samples.newMainProblem.extProblemCode}">
                {{problem.extProblemCode}} : {{problem.problemName}}</li>
            </ul>
          </div>
        </p-fieldset>
       </div>
       <div style="padding-bottom: 1em;">
        <p-fieldset legend="Comments" toggleable="true">
          <div class="row">
          <div class="col-md-7 ">
            <textarea *ngIf="samples!=null" name="comment" rows="5" cols="70" placeholder="No Comments for NC Sample" 
                      [(ngModel)]="samples.comments" readonly >  
            </textarea>
          </div>
          <div class="col-md-4 ">
            <div class="row">
              <p-toggleButton [(ngModel)]="processSelected"  onLabel="Process" offLabel="Process" [style]="{ 'border-color': '#21cf3e','border-style': 'solid','margin-bottom': '1em','border-width':'medium'}"></p-toggleButton>
            </div>
            <div class="row">
              <p-toggleButton [(ngModel)]="rescueSelected"  onLabel="Rescue" offLabel="Rescue" [style]="{ 'border-color': 'orange','border-style': 'solid','margin-bottom': '1em','border-width':'medium'}"></p-toggleButton>
            </div>
            <div class="row">
              <p-toggleButton [(ngModel)]="removeSelected"  onLabel="Remove" offLabel="Remove" [style]="{ 'border-color': 'red','border-style': 'solid','margin-bottom': '1em','border-width':'medium'}"></p-toggleButton>
            </div>
          </div>
        </div>
        </p-fieldset>
      </div>
      </div>
    </div>    


  <p-dialog header="{{batchID + ' Comments'}}" [(visible)]="showCommentDialog" [modal]="true" position="top">
    <div class="border border-info" id="commentShowDiv">
      <div class="ui-g-12">
        <div class="ui-g-12 p-0 rounded border border-secondary commentBubble">
          <div class="ui-g-11 pb-0">
            <label></label>
          </div>
          <div class="ui-g-1 pb-0">
            <button type="button" class="float-right btn btn-outline-secondary border-0 p-0"><em class="fa fa-window-minimize"></em></button>
            <button type="button" class="float-right btn btn-outline-secondary border-0 p-0"><em class="fa fa-window-maximize"></em></button>
          </div>
          <div>
            <div>
              <div class="ui-g-12 p-0 commentBubbleSection">
                <div class="ui-g-12 commentPUIDDate">
                  <label></label>
                </div>
                <div class="ui-g-12 commentPUIDDate font-weight-bold">
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <p-footer>
    <button pButton label="OK"  (click)="showCommentDialog = false"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Enter BatchID"  [(visible)]="batchIdPopup" [modal]="true" [dismissableMask]="true" (onHide)="batchIdToDeleteSample=null">
  <label class="text-danger">Scan Valid Batch ID To Delete Sample</label>
  <div>
    <input class="batchInput" pInputText type="text"  name="comment" [(ngModel)]="batchIdToDeleteSample"/>
  </div>
  <p-footer>
    <button pButton type="button" label="Delete" [disabled]="deleteDisabledIf()" (click)="deleteSample(idInput)"></button>
  </p-footer>
</p-dialog>

<p-dialog  [style.width]="'500px'" header="Select Redo Reason" [(visible)]="redoReasonsPopup" [modal]="true" [dismissableMask]="true" position="top">
  <div *ngIf="noRedoReasonConfiguredForLab">
    No active redo reasons found! please configure redo reasons in MDM.
  </div>

  <div *ngFor="let reason of redoReasons">
    <p-radioButton name="redoGroup" value="{{reason.reasonName}}" label="{{reason.reasonCode+'-'+reason.reasonName}}" [(ngModel)]="selectedRedoReason" (onClick)="getRedoResonsDetails()"></p-radioButton>
  </div>
  <div *ngIf="selectedRedoReason">
    <hr style="width:100%;text-align:left;margin-left:0">
  </div>

  <div class="ui-inputgroup" id="inputClass" *ngIf="selectedRedoReason">
    <button pButton class="theme-button noHover labelButton" type="button" label="Channel"></button>
    <p-multiSelect [style]="{'width':'200px'}" id="kitChannel" [options]="redoChannelList" filterPlaceHolder="Select Channel"
      [(ngModel)]="selectedRedoReasonChannel" [disabled]="askForChannelDisabled">
    </p-multiSelect>
  </div>
  <div class="ui-inputgroup" id="inputClass" *ngIf="selectedRedoReason">
    <button pButton class="theme-button noHover labelButton" type="button" label="Redo Step"></button>
    <p-dropdown [style]="{'width':'200px'}" id="redoStep" [options]="redoStepList" placeholder="Select Redo Step"
    [(ngModel)]="selectedRedoReasonStep">
  </p-dropdown>
  </div>
  <div style="padding-top: 6%;">
    &nbsp;
  </div>
  <div *ngIf="selectedRedoReason">
    {{selectedRedoReasonInfo}}
  </div>

  <div *ngIf="selectedRedoReason == 'Other'">
    <input pInputText type="text" style="margin-top:3%" size="40" placeholder="Enter Redo Reason" [(ngModel)]="enteredRedoReason"/>
  </div>
  <p-footer>
    <button pButton type="button" label="Done" [disabled]="redoButtonDisabledIf()" (click)="redoAction()"></button>
  </p-footer>
</p-dialog>

<p-dialog header="Confirmation" [(visible)]="removeUnnecessaryPopup" [modal]="true" [dismissableMask]="true">
    <label>Please Select The Batch to Complete...Other Batches will be Removed & Data transfer of results for plate has
      to be done manually!! </label>
    <div *ngFor="let batchId of parentBatches">
      <p-radioButton *ngIf="batchId != searchedBatch.batchID" name="batchgroup" value="{{batchId}}" label="{{batchId}}" [(ngModel)]="selectedBatchIdToComplete">
      </p-radioButton>
    </div>
  <p-footer>
    <button pButton type="button" label="Delete" [disabled]="!selectedBatchIdToComplete"
      (click)="removeUnnecessaryRedo()"></button>
  </p-footer>
</p-dialog>


<p-dialog header="Result Details"  [(visible)]="showResultDialog" [modal]="true" [dismissableMask]="true" position="top">

</p-dialog>

<p-dialog header="Mark as Non-Conformity" [(visible)]="isNCSamplePopup" [contentStyle]="{'width':'520px'}" (onHide)="barcode=''">
  <div class="ui-inputgroup" style="margin-top: 10px;justify-content: left;">
    <button pButton style="margin-right:35px" type="button" label="Box ID:"></button>
    <input pInputText name="ncboxid" [(ngModel)]="ncboxId" id="boxidnc"
      style="width: 160px; border-radius: 1px; height: 30px;" placeholder="Provide Box ID"/>
  </div>
  <div class="ui-inputgroup" style="margin-top: 10px;justify-content: left;"> 
    <button pButton style="margin-right:16px" type="button" label="Bar Code:"></button>
    <input pInputText name="ncbarcode" [(ngModel)]="ncBarcode" id="barcodenc"
      style="width: 160px; border-radius: 1px; height: 30px;" placeholder="Provide Bar Code"/> 
  </div><br>
  <div class="ui-inputgroup" style="margin-top: 10px;justify-content: center;">
    <button pButton class="button-small" style="margin-right:16px" type="button" label="Save Sample"></button>
    <button pButton class="button-small" type="button" label="Barcode Issue"></button> 
  </div>
</p-dialog>

<p-dialog header="Barcode Printing"  [(visible)]="showBarcodePrinting" [modal]="true" [dismissableMask]="true" position="top" [style.width]="'800px'" >
  <div style="width:'100rem'">
    <div class="ui-g-9" id="inputClass">
      <button pButton class="theme-button labelButton" type="button" label="Barcode Format"></button>
        <p-dropdown placeholder="Barcode Format" styleClass="printer-dropdown" [options]="templateList"
                        optionLabel="templateName" [style]="{'width':'50%'}"
                        [(ngModel)]="selectedTemplate">
                        </p-dropdown>
    </div>
    <br>
    <div class="ui-g-9" id="inputClass">
      <button pButton class="theme-button labelButton" type="button" label="Select Printer"></button>
      <p-dropdown placeholder="Printer" styleClass="printer-dropdown" [options]="printerList"
                        optionLabel="name" [style]="{'width':'50%'}"
                        [disabled]="!(printerList && printerList.length)"
                        [(ngModel)]="printer">
      </p-dropdown>
    </div>
    <div class="ui-g-9" id="inputClass">
      <button pButton class="theme-button labelButton" type="button" label="No. of Barcode"></button>
      <p-spinner name="poolSize" size="3" [(ngModel)]="barcodeCount"
      [min]="1" required="true">
    </p-spinner>
    </div>
    <br>
    <div class="ui-g-12" >
      <button pButton type="button" icon="pi pi-print" class="printer-button" (click)="print()"
    [disabled]="!printer || !selectedTemplate || !barcodeCount || (barcodeCount < 1)"></button>
    </div>
    </div>
</p-dialog>

<p-dialog header="Edit Unwrapping Entry" [(visible)]="editUnwrappedSamplePopup" showEffect="fade" [modal]="true" [style]="{width: '400px'}">
  <div>
    <div class="ui-inputgroup batchIDField" id="inputClass">
      <button pButton class="theme-button noHover labelButton" type="button"
        label="Box ID"></button>
      <input pInputText name="boxId" style="width: 160px;" id="boxId"
        [(ngModel)]="updatedDepoolingRetestDTO.boxID" disabled/>
    </div>
    <div class="ui-inputgroup batchIDField" id="inputClass">
      <button pButton class="theme-button noHover labelButton" type="button"
        label="School ID"></button>
      <input pInputText name="schoolId" style="width: 160px;" id="schoolId"
        [(ngModel)]="updatedDepoolingRetestDTO.schoolID" />
    </div>
    <div class="ui-inputgroup batchIDField" id="inputClass">
      <button pButton class="theme-button noHover labelButton" type="button"
        label="Bag ID"></button>
      <input pInputText name="bagID" style="width: 160px;" id="bagId"
        [(ngModel)]="updatedDepoolingRetestDTO.bagID" />
    </div>
    <div class="ui-inputgroup batchIDField" id="inputClass">
      <button pButton class="theme-button noHover labelButton" type="button"
        label="Falcon ID"></button>
      <input pInputText name="falconID" style="width: 160px;" id="falconId"
        [(ngModel)]="updatedDepoolingRetestDTO.falconID" />
    </div>
  </div>
  <div class="ui-g-12">
    <div class="ui-g-4">
    </div>
    <div class="ui-g-8">
      <button class="btn btn-primary" (click)="updateUnwrappedEntry()" [disabled]="disableEditUnwrappedEntry()">Update Entry</button>
    </div>
  </div>
</p-dialog>